import { noop } from '@kofno/piper';
import { Task } from 'taskarian';
import { editTemplatesCheck, updateLearningCollection } from '.';
import LearningCollectionEditStore from '..';
import { PreviewingUpdating } from '../Types';
import previewing from './Preview';
import { nothing } from 'maybeasy';

const previewUpdating = (store: LearningCollectionEditStore, state: PreviewingUpdating) =>
  updateLearningCollection(store, state, nothing())
    .map(previewing(store, state))
    .orElse((error) =>
      editTemplatesCheck(state.learningCollectionEditFormResource)
        .map(({ template }) =>
          store.editFormSubmissionError(state.learningCollectionEditFormResource, error, template),
        )
        .orElse(() => Task.succeed(store.templateLoadError())),
    )
    .fork(noop, noop);

export default previewUpdating;
